import React, {useEffect, useLayoutEffect} from 'react';
import {PageInfo} from "./components/PageInfo";
import {checkCustomerRequestFunction, configRequestFunction, subscriptionsRequestFunction} from "./redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {Subscriptions} from "./components/Subscriptions";
import {Header} from "./components/Header";
import {Footer} from "./components/Footer";
import {SuccessPopup} from "./components/SuccessPopup";
import {EmptyBox} from "./components/EmptyBox";
import {IvalidEmail} from "./components/IvalidEmail";
import {ERROR_POPUP} from "./redux/types";

function App() {
    const dispatch = useDispatch()
    const checkCustomerRequest = useSelector(state => state.app.checkCustomerRequest)
    const configRequest = useSelector(state => state.app.configRequest)
    const subscriptionsRequest = useSelector(state => state.app.subscriptionsRequest)
    const userEmail = useSelector(state => state.app.userEmail)
    const userMarker = useSelector(state => state.app.userMarker)
    const errorEmail = useSelector(state => state.app.errorEmail)
    const errorMarker = useSelector(state => state.app.errorMarker)
    const errorPopup = useSelector(state => state.app.errorPopup)
    const isMobile = useSelector(state => state.app.isMobile)
    const isEmailInvalid = useSelector(state => state.app.isEmailInvalid)
    useEffect(() => {
        if (!errorEmail && !errorMarker) {
            if (checkCustomerRequest === false) {
                dispatch(checkCustomerRequestFunction(userEmail,userMarker));
            }
        } else{
            dispatch({type: ERROR_POPUP, payload: 'email_not_found'})
        }
        if (configRequest === false) {
            dispatch(configRequestFunction());
        }
        if (subscriptionsRequest === false) {
            dispatch(subscriptionsRequestFunction());
        }
    }, [dispatch, checkCustomerRequest]);

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 1024 && isMobile === false) {
                window.location.reload();
            }
            if (window.innerWidth > 1024 && isMobile === true) {
                window.location.reload();
            }
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, [isMobile]);
    if (errorPopup) {
        return (
            <React.Fragment>
                <Header/>
                <EmptyBox/>
                <Footer/>
            </React.Fragment>
        );
    }

    if (isEmailInvalid) {
        return (
            <React.Fragment>
                <Header/>
                <IvalidEmail/>
                <Footer/>
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            <Header/>
            <PageInfo/>
            <Subscriptions/>
            <Footer/>
            <SuccessPopup/>
        </React.Fragment>
    );
}

export default App;
